// app 也就是公司的最原始定义信息
import time from '../time';
import {DB, ExecuteResult} from './index';

const upsert_sql =
    'insert into t_app(' +
    'appkey, main_appkey, plat, company, company_short,' +
    'company_desc, category, admin_uid, ruid, status,' +
    'ctime, lutime, lctime' +
    ') values (' +
    '?, ?, ?, ?, ?,' +
    '?, ?, ?, ?, ?,' +
    '?, ?, ?' +
    ' ) ON CONFLICT(appkey) DO UPDATE SET' +
    ' main_appkey=?, plat=?, company=?, company_short=?,' +
    ' company_desc=?, category=?, admin_uid=?, ruid=?, status=?,' +
    ' ctime=?, lutime=?;';

// 增加或者更新应用信息
export async function app_upsert(db: DB, app: App): Promise<ExecuteResult> {
    const a = AppToEntity(fixApp(app));
    const timeUnix = time.toUnixMillSecond(time.now());
    a.lutime = timeUnix;
    a.lctime = timeUnix;
    const params = [];
    // INSERT
    params.push(
        ...[a.appkey, a.main_appkey, a.plat, a.company, a.company_short],
    );
    params.push(...[a.company_desc, a.category, a.admin_uid, a.ruid, a.status]);
    params.push(...[a.ctime, a.lutime, a.lctime]);
    // UPDATE
    params.push(...[a.main_appkey, a.plat, a.company, a.company_short]);
    params.push(...[a.company_desc, a.category, a.admin_uid, a.ruid, a.status]);
    params.push(...[a.ctime, a.lutime]);
    const r = await db.Execute(upsert_sql, params);
    return r;
}

export async function app_query_one(
    db: DB,
    appkey: string,
): Promise<{error: any; app?: App}> {
    const sql =
        'select' +
        ' appkey, main_appkey, plat, company, company_short,' +
        ' company_desc, category, admin_uid, ruid, status,' +
        ' ctime, lutime, lctime' +
        ` from t_app where appkey=`;
    const r = await db.Query(sql, [appkey]);
    if (r.error) {
        return {error: r.error};
    }
    if (!(r.data && r.data.length > 0)) {
        return {error: null};
    }
    const d = r.data[0] as Entity;
    return {error: null, app: EntityToApp(d)};
}

function EntityToApp(a: Entity): App {
    const d: App = {
        appkey: a.appkey, //  内部：appkey documentid
        mainAppkey: a.main_appkey, //  内部：主应用 用来关联B P F端
        plat: a.plat, // B P F 端 这里再内置一个 S - KingKong系统
        company: a.company, // 公司全称
        companyShort: a.company_short, // 公司简称
        companyDesc: a.company_desc, // 公司描述
        category: JSON.parse(a.category), // 分类
        adminUserId: a.admin_uid, // 企业超级管理员账号信息
        ruid: a.ruid, // 平台联系人
        status: a.status, // 标识 "" - 正常 1 closed - 关闭 deleted - 删除
        ctime: a.ctime, // 创建时间 单位秒
        lutime: a.lutime, // 本地记录的上一次更新时间，每次拿完数据检查下，如果超过了10分钟就重新获取下企业信息
        lctime: a.lctime, // 记录的创建时间
    };
    return d;
}

function AppToEntity(a: App): Entity {
    const d: Entity = {
        appkey: a.appkey, //  内部：appkey documentid
        main_appkey: a.mainAppkey, //  内部：主应用 用来关联B P F端
        plat: a.plat, // B P F 端 这里再内置一个 S - KingKong系统
        company: a.company, // 公司全称
        company_short: a.companyShort, // 公司简称
        company_desc: a.companyDesc, // 公司描述
        category: JSON.stringify(a.category), // 分类
        admin_uid: a.adminUserId, // 企业超级管理员账号信息
        ruid: a.ruid, // 平台联系人
        status: a.status, // 标识 "" - 正常 1 closed - 关闭 deleted - 删除
        ctime: a.ctime, // 创建时间 单位秒
        lutime: a.lutime, // 本地记录的上一次更新时间，每次拿完数据检查下，如果超过了10分钟就重新获取下企业信息
        lctime: a.lctime, // 记录的创建时间
    };
    return d;
}

type Entity = {
    appkey: string; //  内部：appkey documentid
    main_appkey: string; //  内部：主应用 用来关联B P F端
    plat: string; // B P F 端 这里再内置一个 S - KingKong系统
    company: string; // 公司全称
    company_short: string; // 公司简称
    company_desc: string; // 公司描述
    category: string; // 分类
    admin_uid: number; // 企业超级管理员账号信息
    ruid: number; // 平台联系人
    status: string; // 标识 "" - 正常 1 closed - 关闭 deleted - 删除
    ctime: number; // 创建时间 单位秒
    lutime: number; // 本地记录的上一次更新时间，每次拿完数据检查下，如果超过了10分钟就重新获取下企业信息
    lctime: number; // 记录的创建时间
};

export type App = {
    appkey: string; //  内部：appkey documentid
    mainAppkey: string; //  内部：主应用 用来关联B P F端
    plat: string; // B P F 端 这里再内置一个 S - KingKong系统
    company: string; // 公司全称
    companyShort: string; // 公司简称
    companyDesc: string; // 公司描述
    category: string[]; // 分类
    adminUserId: number; // 企业超级管理员账号信息
    ruid: number; // 平台联系人
    status: string; // 标识 "" - 正常 1 closed - 关闭 deleted - 删除
    ctime: number; // 创建时间 单位秒
    // 本地字段
    lutime: number; // 本地记录的上一次更新时间，每次拿完数据检查下，如果超过了10分钟就重新获取下企业信息
    lctime: number; // 记录的创建时间
};

function fixApp(a: App): App {
    return Object.assign({}, defaultApp, a);
}

const defaultApp: App = {
    appkey: '', //  内部：appkey documentid
    mainAppkey: '', //  内部：主应用 用来关联B P F端
    plat: '', // B P F 端 这里再内置一个 S - KingKong系统
    company: '', // 公司全称
    companyShort: '', // 公司简称
    companyDesc: '', // 公司描述
    category: [], // 分类
    adminUserId: 0, // 企业超级管理员账号信息
    ruid: 0, // 平台联系人
    status: '', // 标识 "" - 正常 1 closed - 关闭 deleted - 删除
    ctime: 0, // 创建时间 单位秒
    lutime: 0,
    lctime: 0,
};
